import React, { createContext, useCallback } from 'react';
import useFitFeature from '../hooks/useFitFeature';
import useResetToDefaultPosition from '../hooks/useResetToDefaultPosition';
import useSetHighlightedFeature from '../hooks/useSetHighlightedFeature';
import useSetSelectedFeature from '../hooks/useSetSelectedFeature';
import { useValidateFeatures } from '../hooks/useValidateFeatures';
import { useApplicationDispatch } from './ApplicationStateProvider';
export var ApplicationActionsContext = /*#__PURE__*/createContext({});

var ApplicationActionsProvider = _ref => {
  var {
    children
  } = _ref;
  var dispatch = useApplicationDispatch();
  var setSelectedFeature = useSetSelectedFeature();
  var setHighlightedFeature = useSetHighlightedFeature();
  var fitFeature = useFitFeature();
  var resetToDefaultPosition = useResetToDefaultPosition();
  var validateFeatures = useValidateFeatures();
  var markSelectableLayersAsRendered = useCallback(() => {
    if (dispatch) {
      dispatch({
        type: 'MARK_SELECTABLE_LAYERS_AS_RENDERED'
      });
    }
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(ApplicationActionsContext.Provider, {
    value: {
      setSelectedFeature,
      setHighlightedFeature,
      fitFeature,
      markSelectableLayersAsRendered,
      resetToDefaultPosition,
      validateFeatures
    }
  }, children);
};

export default ApplicationActionsProvider;